import React, { useState, useEffect } from 'react';
import { Routes, Route, NavLink, Navigate, useNavigate } from "react-router-dom";
import axios from 'axios';
import CryptoJS from "crypto-js";

import Menubar from './Menubar';
import Dashboard from './Dashboard';
import VisualsDashboard from './VisualsDashboard';
import Footer from './Footer';
import Companies from '../Companies';
import UserManagement from '../UserManagement';
import Recentsms from '../Messages/Recentsms';
import Failedsms from '../Messages/Failedsms';
import Statement from '../Statement';
import Contacts from '../Contacts';
import Trashsms from '../Messages/Trashsms';
import Draftsms from '../Messages/Draftsms';
import Sendsms from '../Messages/Sendsms';
import NewMessage from '../Messages/NewMessage';
import SendNewMessage from '../Messages/SendNewMessage';
import ContactsByGroup from '../ContactsByGroup';
import ImportMessages from '../Messages/ImportMessages';
import ImportLines from '../Messages/ImportLines';
import CompanyCreditHistory from '../CompanyCreditHistory';
import Filterrecentsms from '../Messages/Filterrecentsms';
import Customfiltersms from '../Messages/Customfiltersms';
import CompanyStatistics from '../CompanyStatistics';
import TopUpHistory from '../TopUpHistory';
import ContactGroupsForCompany from '../ContactGroupsForCompany';
import { secret_key, storedData, API_URL } from '../Constants';
import { BiSolidUserCircle } from 'react-icons/bi';
import BuyUnits from '../BuyUnits';




import './Sidebar.css'; // Import custom CSS for the sidebar
import UserManual from '../UserManual';

const Sidebar = () => {
  const navigate = useNavigate();
  
  // Decrypt stored user data
  const userData = storedData
    ? JSON.parse(CryptoJS.AES.decrypt(storedData, secret_key).toString(CryptoJS.enc.Utf8))
    : null;

  // State management for sub-menus and authentication
  const [isSubMenuVisible, setSubMenuVisible] = useState(false);
  const [isContMenuVisible, setContMenuVisible] = useState(false);
  const [isRepMenuVisible, setRepMenuVisible] = useState(false);
  const [isSetMenuVisible, setSetMenuVisible] = useState(false);
  const [isFilterVisible, setFilterVisible] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(true);
  const [isManualVisible, setIsManualVisible] = useState(false);

  const [isPurchasesMenuVisible, setIsPurchasesMenuVisible] = useState(false);
  // Toggle functions for menus
  const toggleSubMenu = () => setSubMenuVisible((prev) => !prev);
  const toggleContMenu = () => setContMenuVisible((prev) => !prev);
  const toggleRepMenu = () => setRepMenuVisible((prev) => !prev);
  const toggleSetMenu = () => setSetMenuVisible((prev) => !prev);
  const toggleFilter = () => setFilterVisible((prev) => !prev);
  const toggleManual = () => setIsManualVisible((prev) => !prev);

  const togglePurchasesMenu = () => {
    setIsPurchasesMenuVisible((prevState) => !prevState);
  };

  // Retrieve and decrypt the token from localStorage
  const encryptedToken = localStorage.getItem('token');
  let decryptedToken = '';

  if (encryptedToken) {
    try {
      const decryptedBytes = CryptoJS.AES.decrypt(encryptedToken, secret_key);
      decryptedToken = decryptedBytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.error('Error decrypting token:', error);
    }
  }
  
  const authToken = `Bearer ${decryptedToken}`;

  // Verify user authentication
  useEffect(() => {
    if (authToken) {
      const config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: `${API_URL}/verify`,
        headers: { 'Authorization': authToken }
      };

      axios.request(config)
        .then((response) => {
          if (response.data.statusCode === 401) {
            setIsAuthenticated(false);
            navigate("/login");
          } else {
            setIsAuthenticated(true);
          }
        })
        .catch((error) => {
          console.error('Authentication verification error:', error);
          setIsAuthenticated(false);
          navigate("/login");
        });
    } else {
      setIsAuthenticated(false);
      navigate("/login");
    }
  }, [authToken, navigate]);

  return (
    <div className="sidebar-container">
  <aside className="main-sidebar">
    <div className="sidebar">
      {/* User Panel */}
      <div className="user-panel">
        <div className="user-image">
          <BiSolidUserCircle size={40} color="#fff" />
        </div>
        <div className="user-info">
          <p>{userData?.full_name}</p>
        </div>
      </div>

      {/* Sidebar Menu */}
      <nav className="menu-nav">
        <ul className="menu-list">
          {/* Dashboard */}
          <li className="menu-item">
            <NavLink
              to="/"
              className={({ isActive }) =>
                isActive ? "menu-link active dashboard-link" : "menu-link dashboard-link"
              }
            >
              <i className="menu-icon fa fa-home" aria-hidden="true" />
              <span className="menu-text">Dashboard</span>
            </NavLink>
          </li>

          {/* Visuals Dashboard */}
          <li className="menu-item">
            <NavLink
              to="/visuals_dashboard"
              className={({ isActive }) =>
                isActive ? "menu-link active visuals-link" : "menu-link visuals-link"
              }
            >
              <i className="menu-icon fa fa-chart-pie" aria-hidden="true" />
              <span className="menu-text">Visuals Dashboard</span>
            </NavLink>
          </li>

          {/* Contacts & Groups */}
          <li className="menu-item">
            <a className="menu-link contacts-link" href="#" onClick={toggleContMenu}>
              <i className="menu-icon fa fa-user" />
              <span className="menu-text">Contacts & Groups</span>
              <i className={`toggle-icon fas ${isContMenuVisible ? 'fa-angle-up' : 'fa-angle-down'}`} />
            </a>
            {isContMenuVisible && (
              <ul className="submenu-list">
                <li className="submenu-item">
                  <NavLink to="/contact_groups" className={({ isActive }) => isActive ? "submenu-link active" : "submenu-link"}>
                    <i className="submenu-icon fa fa-angle-double-right" />
                    Contact Groups
                  </NavLink>
                </li>
                <li className="submenu-item">
                  <NavLink to="/contacts" className={({ isActive }) => isActive ? "submenu-link active" : "submenu-link"}>
                    <i className="submenu-icon fa fa-angle-double-right" />
                    Contacts
                  </NavLink>
                </li>
              </ul>
            )}
          </li>

          {/* Purchases */}
          <li className="menu-item">
            <a className="menu-link purchases-link" href="#" onClick={togglePurchasesMenu}>
              <i className="menu-icon fa fa-shopping-cart" />
              <span className="menu-text">Purchases</span>
              <i className={`toggle-icon fas ${isPurchasesMenuVisible ? 'fa-angle-up' : 'fa-angle-down'}`} />
            </a>
            {isPurchasesMenuVisible && (
              <ul className="submenu-list">
            {/*     <li className="submenu-item">
                  <div className="submenu-link">
                    <i className="submenu-icon fa fa-angle-double-right" />
                    <BuyUnits />
                  </div>
                </li> */}
                <li className="submenu-item">
                  <NavLink to="/topup_history" className={({ isActive }) => isActive ? "submenu-link active" : "submenu-link"}>
                    <i className="submenu-icon fa fa-angle-double-right" />
                    Purchase History
                  </NavLink>
                </li>
              </ul>
            )}
          </li>

          {/* Messages */}
          <li className="menu-item">
            <a className="menu-link messages-link" href="#" onClick={toggleSubMenu}>
              <i className="menu-icon fa fa-comment" />
              <span className="menu-text">Messages</span>
              <i className={`toggle-icon fas ${isSubMenuVisible ? 'fa-angle-up' : 'fa-angle-down'}`} />
            </a>
            {isSubMenuVisible && (
              <ul className="submenu-list">
                {["new_message", "draft", "sent", "imported_messages"].map(path => (
                  <li key={path} className="submenu-item">
                    <NavLink to={`/${path}`} className={({ isActive }) => isActive ? "submenu-link active" : "submenu-link"}>
                      <i className="submenu-icon fa fa-angle-double-right" />
                      {path.replace("_", " ").replace(/^\w/, c => c.toUpperCase())}
                    </NavLink>
                  </li>
                ))}
              </ul>
            )}
          </li>

          {/* Reports */}
          <li className="menu-item">
            <a className="menu-link reports-link" href="#" onClick={toggleRepMenu}>
              <i className="menu-icon fa fa-bar-chart" />
              <span className="menu-text">Reports</span>
              <i className={`toggle-icon fas ${isRepMenuVisible ? 'fa-angle-up' : 'fa-angle-down'}`} />
            </a>
            {isRepMenuVisible && (
              <ul className="submenu-list">
                {userData?.role_id === 4 && (
                  <li className="submenu-item">
                    <NavLink to="/company_stats" className={({ isActive }) => isActive ? "submenu-link active" : "submenu-link"}>
                      <i className="submenu-icon fa fa-angle-double-right" />
                      Company Stats
                    </NavLink>
                  </li>
                )}
                {[
                  { to: "/statement", text: "Statement" },
                  { to: "/topup_history", text: "Top Up History" },
                  { to: "/failed_sms", text: "Failed Messages" },
                  { to: "/recent_sms", text: "Recent Messages" }
                ].map(({ to, text }) => (
                  <li key={to} className="submenu-item">
                    <NavLink to={to} className={({ isActive }) => isActive ? "submenu-link active" : "submenu-link"}>
                      <i className="submenu-icon fa fa-angle-double-right" />
                      {text}
                    </NavLink>
                  </li>
                ))}
              </ul>
            )}
          </li>

          {/* Filter Messages */}
          <li className="menu-item">
            <a className="menu-link filter-link" href="#" onClick={toggleFilter}>
              <i className="menu-icon fa fa-filter" />
              <span className="menu-text">Filter Messages</span>
              <i className={`toggle-icon fas ${isFilterVisible ? 'fa-angle-up' : 'fa-angle-down'}`} />
            </a>
            {isFilterVisible && (
              <ul className="submenu-list">
                <li className="submenu-item">
                  <NavLink to="/recent_filter" className={({ isActive }) => isActive ? "submenu-link active" : "submenu-link"}>
                    <i className="submenu-icon fa fa-angle-double-right" />
                    Last 7 days
                  </NavLink>
                </li>
                <li className="submenu-item">
                  <NavLink to="/custom_filter" className={({ isActive }) => isActive ? "submenu-link active" : "submenu-link"}>
                    <i className="submenu-icon fa fa-angle-double-right" />
                    Last 30 days
                  </NavLink>
                </li>
              </ul>
            )}
          </li>

          {/* User Manual */}
          <li className="menu-item">
            <a className="menu-link user-manual-link" href="#" onClick={toggleManual}>
              <i className="menu-icon fa fa-book" />
              <span className="menu-text">User Manual</span>
              <i className={`toggle-icon fas ${isManualVisible ? 'fa-angle-up' : 'fa-angle-down'}`} />
            </a>
            {isManualVisible && (
              <ul className="submenu-list">
                <li className="submenu-item">
                  <NavLink to="/user_manual" className={({ isActive }) => isActive ? "submenu-link active" : "submenu-link"}>
                    <i className="submenu-icon fa fa-angle-double-right" />
                    Getting Started
                  </NavLink>
                </li>
              </ul>
            )}
          </li>

          {/* Settings - Admin Only */}
          {userData?.role_id === 4 && (
            <li className="menu-item">
              <a className="menu-link settings-link" href="#" onClick={toggleSetMenu}>
                <i className="menu-icon fa fa-gear fa-spin" />
                <span className="menu-text">Settings</span>
                <i className={`toggle-icon fas ${isSetMenuVisible ? 'fa-angle-up' : 'fa-angle-down'}`} />
              </a>
              {isSetMenuVisible && (
                <ul className="submenu-list">
                  <li className="submenu-item">
                    <NavLink to="/companies" className={({ isActive }) => isActive ? "submenu-link active" : "submenu-link"}>
                      <i className="submenu-icon fa fa-angle-double-right" />
                      Companies
                    </NavLink>
                  </li>
                  <li className="submenu-item">
                    <NavLink to="/users" className={({ isActive }) => isActive ? "submenu-link active" : "submenu-link"}>
                      <i className="submenu-icon fa fa-angle-double-right" />
                      Users
                    </NavLink>
                  </li>
                </ul>
              )}
            </li>
          )}
        </ul>
      </nav>
    </div>
  </aside>
  <Menubar />
  <div className="content-container">
    <div className="content-wrapper">
 <Routes>
            <Route path="" element={isAuthenticated ? <Dashboard /> : <Navigate to="/login" />} />
            <Route path="visuals_dashboard" element={isAuthenticated ? <VisualsDashboard /> : <Navigate to="/login" />} />
            <Route path="new_message" element={isAuthenticated ? <NewMessage /> : <Navigate to="/login" />} />
            <Route path="sent" element={isAuthenticated ? <Sendsms /> : <Navigate to="/login" />} />
            <Route path="draft" element={isAuthenticated ? <Draftsms /> : <Navigate to="/login" />} />
            <Route path="trash" element={isAuthenticated ? <Trashsms /> : <Navigate to="/login" />} />
            <Route path="contact_groups" element={isAuthenticated ? <ContactGroupsForCompany /> : <Navigate to="/login" />} />
            <Route path="contacts" element={isAuthenticated ? <Contacts /> : <Navigate to="/login" />} />
            <Route path="topup_history" element={isAuthenticated ? <TopUpHistory /> : <Navigate to="/login" />} />
            <Route path="statement" element={isAuthenticated ? <Statement /> : <Navigate to="/login" />} />
            <Route path="failed_sms" element={isAuthenticated ? <Failedsms /> : <Navigate to="/login" />} />
            <Route path="company_stats" element={isAuthenticated ? <CompanyStatistics /> : <Navigate to="/login" />} />
            <Route path="recent_sms" element={isAuthenticated ? <Recentsms /> : <Navigate to="/login" />} />
            <Route path="users" element={isAuthenticated ? <UserManagement /> : <Navigate to="/login" />} />
            <Route path="companies" element={isAuthenticated ? <Companies /> : <Navigate to="/login" />} />
            <Route path="prev_message/:id" element={isAuthenticated ? <SendNewMessage /> : <Navigate to="/login" />} />
            <Route path="contactlist/:groupid" element={isAuthenticated ? <ContactsByGroup /> : <Navigate to="/login" />} />
            <Route path="imported_messages" element={isAuthenticated ? <ImportMessages /> : <Navigate to="/login" />} />
            <Route path="import_lines/:id" element={isAuthenticated ? <ImportLines /> : <Navigate to="/login" />} />
            <Route path="units_history/:companyid" element={isAuthenticated ? <CompanyCreditHistory /> : <Navigate to="/login" />} />
            <Route path="recent_filter" element={isAuthenticated ? <Filterrecentsms /> : <Navigate to="/login" />} />
            <Route path="custom_filter" element={isAuthenticated ? <Customfiltersms /> : <Navigate to="/login" />} />
            <Route path="user_manual" element={isAuthenticated ? <UserManual /> : <Navigate to="/login" />} />
          </Routes>
    </div>
  </div>
</div>

  );
};

export default Sidebar;
